import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer-cb-section">
      <div className="footer-cb-container">
        {/* Contact Information Section */}
        <div className="footer-cb-contact-section">
          <div className="footer-cb-contact-content">
            <div className="footer-cb-contact-left">
              <h2 className="footer-cb-contact-title">
                Contact<br />
                Information
              </h2>
              <p className="footer-cb-contact-description">
                We're here to walk alongside you on your wellness journey. Whether you have questions about our services, want to book an appointment, or simply need guidance, our team is ready to help.
              </p>

              <div className="footer-cb-contact-details">
                <div className="footer-cb-contact-item">
                  <h3 className="footer-cb-contact-label">Address:</h3>
                  <p className="footer-cb-contact-text">
                  PLOT NO 516/1754/1755/1757, MARUTI CORNOR, 3RD FLOOR,
                  PATIA, BHUBANESWAR, Khordha, Orissa, India, 751024 
                  </p>
                </div>

                <div className="footer-cb-contact-item">
                  <h3 className="footer-cb-contact-label">Phone:</h3>
                  <p className="footer-cb-contact-text">
                    +91 94371 65763<br />
                    support@cbge.in
                  </p>
                </div>
              </div>
            </div>

            <div className="footer-cb-contact-right">
              <div className="footer-cb-map-wrapper">
                <div className="footer-cb-map-placeholder">
                  <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7452.193569864852!2d85.80661294185622!3d20.353639783528646!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a190921eb9a2be1%3A0xfcb626d43fa8c05!2sChandaka%20Industrial%20Estate%2C%20K%20I%20I%20T%20University%2C%20Patia%2C%20Bhubaneswar%2C%20Odisha%20751024!5e1!3m2!1sen!2sin!4v1769681312709!5m2!1sen!2sin" width="100%" height="450" 
                   allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Navigation Links */}
        <div className="footer-cb-nav">
          <Link to="/" className="footer-cb-link">Home</Link>
          <Link to="/services" className="footer-cb-link">Our Services</Link>
          <Link to="/about" className="footer-cb-link">About Us</Link>
          <Link to="/team" className="footer-cb-link">Team</Link>
          <Link to="/contact" className="footer-cb-link">Contacts</Link>
        </div>

        {/* Bottom Section */}
        <div className="footer-cb-bottom">
          {/* Copyright Text */}
          <p className="footer-cb-copyright">
          © Copyright 2026 | Reserved by <span className='text-warning'>Ohhpro Technologies Pvt.Ltd</span>
          </p>

          {/* Social Icons */}
          <div className="footer-cb-social">
            <a href="#facebook" className="footer-cb-social-link" aria-label="Facebook">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
            <a href="#instagram" className="footer-cb-social-link" aria-label="Instagram">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" stroke="currentColor" strokeWidth="2"/>
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" stroke="currentColor" strokeWidth="2"/>
                <circle cx="17.5" cy="6.5" r="1.5" fill="currentColor"/>
              </svg>
            </a>
            <a href="#twitter" className="footer-cb-social-link" aria-label="Twitter/X">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 4l9.5 16L22 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M4 20l16-16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;